export default __webpack_public_path__ + "static/media/link-event.03da7db5.svg";